import CONFIG from 'Config/index';
import BaseWSClient from 'WSClient/BaseWSClient';

export default class NoAuthWSClient extends BaseWSClient {
  constructor() {
    super();
    // do not open ws for prerender
    if (!window.__prerender) {
      this.open();
    }
  }

  async _connect() {
    this.client = new WebSocket(`${CONFIG.urls.notificationWS}noauth`);
    return Promise.resolve(this.client);
  }
}
